"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.default = void 0;
var _react = require("@emotion/react");
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const styles = exports.styles = {
  height: height => /*#__PURE__*/(0, _react.css)("height:", height, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:height;")),
  width: width => /*#__PURE__*/(0, _react.css)("width:", width, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:width;")),
  objectFit: value => /*#__PURE__*/(0, _react.css)("object-fit:", value, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:objectFit;")),
  responsive: process.env.NODE_ENV === "production" ? {
    name: "1hyxgad",
    styles: "max-width:100%;height:auto"
  } : {
    name: "12hqw6b-responsive",
    styles: "max-width:100%;height:auto;label:responsive;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  placeholder: theme => /*#__PURE__*/(0, _react.css)("background-color:", theme.gray10, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:placeholder;")),
  radius: radius => /*#__PURE__*/(0, _react.css)("border-radius:", radius, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:radius;"))
};
var _default = exports.default = styles;